/**
@element com-throttle
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';

export const COMThrottleBehavior = function (superClass) {
  return class extends superClass {

    static get properties() {
      return {
        debounce: {
          type: Number,
          value: 250
        }
      }
    }

    /**
     * @desc throttle check function so we don't check more than needed
     * @param {Function} throttleFunction checking function
     * @param {Number} throttle interval
     * @return {Function} check function wrapped with throttling
     */
    throttle(throttleFunction, throttleInterval) {
      var timerId, callContext, callArguments, nextEligibleCallTime = Date.now(),
        cachedReturn;

      return function() {
        var now;
        callContext = this;
        callArguments = arguments;

        if (timerId) return cachedReturn;

        now = Date.now();

        if (now < nextEligibleCallTime) {
          timerId = setTimeout(executeFunction, nextEligibleCallTime - now);
          return cachedReturn;
        } else {
          return executeFunction(now);
        }
      };

      /**
       * internal function to execute function
       * @param {Number} milliseconds
       * @return {Mixed} function results
       */
      function executeFunction(now) {
        timerId = 0;
        nextEligibleCallTime = (now || Date.now()) + throttleInterval;
        cachedReturn = throttleFunction.apply(callContext, callArguments);
        return cachedReturn;
      }
    }

  }
}

class COMThrottle extends COMThrottleBehavior(PolymerElement) {
  static get is() { return 'com-throttle'; }
}
customElements.define(COMThrottle.is, COMThrottle);